import { render, staticRenderFns } from "./addBackDialog.vue?vue&type=template&id=5cabb654&scoped=true"
import script from "./addBackDialog.vue?vue&type=script&lang=js"
export * from "./addBackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cabb654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cabb654')) {
      api.createRecord('5cabb654', component.options)
    } else {
      api.reload('5cabb654', component.options)
    }
    module.hot.accept("./addBackDialog.vue?vue&type=template&id=5cabb654&scoped=true", function () {
      api.rerender('5cabb654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen-product/components/addBackDialog.vue"
export default component.exports